import { Phone } from "../../src/components/phoneUI/PhoneClass";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { joe } from "../characters/Joe";
import { mc } from "../characters/MC";
import { images } from "./images";
import { V8JoeCallingAfter, V8VanessaJoeMCThreesomeAfter } from "./V8";
// TODO: write conversation for Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessa===false

export const V8JoeCalling = async (): Promise<any> => {

    await Phone.showMessagesUI({ name: joe.name }, async () => {
        if (Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessa) {
            Phone.setMessage({
                character: joe.character, text: `My man!!! I got everything set up for tonight! It's gonna be epic!
We'll pick you up later, make sure you take a shower and shit!`, options: { wait: false }
            });
            Phone.setMessage({ character: mc.character, text: `I can't believe you're actually gonna follow this through.` });
            Phone.setMessage({ character: joe.character, text: `I know! I can't believe it either, but I'm a bit excited for it.` });
            Phone.setMessage({ character: mc.character, text: `I can understand! I'll see you later then.` });
            Phone.setMessage({
                character: joe.character, text: `You betcha!
Well, I'm gonna work out for a bit and get ready as well. I'll call you when we are outside to pick ya up!` });


        } else if (Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessa === false) {
            // TODO: test this part
            Phone.setMessage({ character: joe.character, text: `Yo`, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `What's up?` });
            Phone.setMessage({ character: mc.character, text: `I wanted to see what's the chance you've changed your mind about what I asked you this morning?` });
            Phone.setMessage({ character: mc.character, text: `To have a threesome with you and Vanessa...?` });
            Phone.setMessage({ character: joe.character, text: `Yeah...` });
            Phone.setMessage({ character: joe.character, text: `What do you say?` });
            Phone.setMessage({
                character: joe.character, text: `I really need you there...
You know me and Vanessa are having problems... And I believe this is a chance for us to fix the relationship.` });
            Phone.setMessage({ character: joe.character, text: `You know what? You don't even have to participate...` });
            Phone.setMessage({ character: mc.character, text: `That's not a real threesome then no?` });
            Phone.setMessage({ character: joe.character, text: `Yeah... But maybe once you are there Vanessa could convince you or something... lol` });
            Phone.setMessage({ character: joe.character, text: `I'm just spitballing here...` });

            Phone.setMessage({ character: joe.character, text: `So... What do you say?` });
            await Phone.setQuestion({
                character: joe.character, question: new Question({ text: `So... What do you say?`, options: { think: false }, key: `v8JoeMorningAgreeThreesomeWithVanessaPhone` })
                    .option({ title: `Agree`, key: true })
                    .option({ title: `Disagree`, key: false })
            });
            if (Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessaPhone) {
                await mc.set((properties) => {
                    properties.v8WentToThreesome = true;
                });
                Phone.setMessage({ character: mc.character, text: `Thinking about it again... It could be fun.` });
                Phone.setMessage({ character: mc.character, text: `You convinced me! I'll join you.` });
                Phone.setMessage({ character: joe.character, text: `Yes!!! You are the man!` });
                Phone.setMessage({ character: joe.character, text: `I'll call you when we are ready to pick you up!` });

            } else {
                await mc.set((properties) => {
                    properties.v8WentToThreesome = false;
                });
                Phone.setMessage({ character: mc.character, text: `I'm sorry man... Answer is still no.` });
                Phone.setMessage({ character: joe.character, text: `Well... I figured as much.` });
                Phone.setMessage({ character: joe.character, text: `Thanks anyway bro.` });
            }



        } else {
            Phone.setMessage({ character: joe.character, text: `yooooooooooooo` });
            Phone.setMessage({ character: mc.character, text: `yoooooooooo` });
            Phone.setMessage({ character: joe.character, text: `sup?` });
            Phone.setMessage({ character: mc.character, text: `Just chilling... What about you?` });
            Phone.setMessage({ character: joe.character, text: `I'm good I'm good...` });
            Phone.setMessage({ character: joe.character, text: `I wanted to ask you a question...` });
            Phone.setMessage({ character: mc.character, text: `Shoot.` });
            let text = 'So...';
            if (Question.globalAnswers.v4SexTapeAgreeToFilm) {
                Phone.setMessage({ character: joe.character, text: `Remember when you agreed to help me and Vanessa with our sex tape?` });
                if (Question.globalAnswers.v4SexTapeFuckedVanessa) {
                    Phone.talk({ character: mc.character, text: `Uh oh.`, options: { think: true } });
                    Phone.talk({ character: mc.character, text: `I hope he hasn't found out that I fucked Vanessa!`, options: { think: true } });

                    Phone.talk({ character: mc.character, text: ``, options: { think: true } });

                }

                Phone.setMessage({ character: mc.character, text: `I do.` });
                text = "And...";
            }

            Phone.setMessage({ character: joe.character, text: `${text} You know how me and Vanessa are having issues right now...` });
            if (Question.globalAnswers.v7JoeGymToldBreakupVanessa) {
                Phone.setMessage({ character: mc.character, text: `Aren't you broken up?` });
                Phone.setMessage({ character: joe.character, text: `Yeah...` });
                Phone.setMessage({ character: joe.character, text: `So... Vanessa just called and she said she needs closure.` });
                Phone.setMessage({ character: mc.character, text: `Really? Her? Seems a bit out of character for her.` });
                Phone.setMessage({ character: joe.character, text: `Well...` });
                Phone.setMessage({ character: joe.character, text: `Her closure is having a threesome...\nShe said that I failed to keep up on that promise I made when we first started dating.` });
                Phone.setMessage({ character: mc.character, text: `Yeah, that's sounds more like her.` });
                Phone.setMessage({ character: joe.character, text: `I know it's kinda weird but I I wanted to ask you to join us...` });

            } else {

                Phone.setMessage({ character: joe.character, text: `We were thinking about how to fix our relationship...` });
                Phone.setMessage({ character: joe.character, text: `Vanessa says we needs to spice up our sex life and apparently we did everything regarding to sex already...` });
                Phone.setMessage({ character: joe.character, text: `So... She insists of me keeping up to my promise on having a threesome...` });
                Phone.setMessage({ character: joe.character, text: `And that's where you come in!` });
            }
            Phone.setMessage({ character: mc.character, text: `So you are asking me to join you so we could fuck Vanessa together?` });
            Phone.setMessage({ character: joe.character, text: `Yeah...` });

            await Phone.setQuestion({
                character: joe.character, question: new Question({ text: `So... What do you say?`, options: { think: false }, key: `v8JoeMorningAgreeThreesomeWithVanessaPhone` })
                    .option({ title: `Agree`, key: true })
                    .option({ title: `Disagree`, key: false })
            });
            if (Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessaPhone) {
                await mc.set((properties) => {
                    properties.v8WentToThreesome = true;
                });
                Phone.setMessage({ character: mc.character, text: `It could be fun.` });
                Phone.setMessage({ character: joe.character, text: `Yes!!! You are the man!` });
                Phone.setMessage({ character: joe.character, text: `I'll call you when we are ready to pick you up!` });

            } else {
                await mc.set((properties) => {
                    properties.v8WentToThreesome = false;
                });
                Phone.setMessage({ character: mc.character, text: `I'm sorry man... I'll have to refuse.` });
                Phone.setMessage({ character: joe.character, text: `Well... I figured as much.` });
                Phone.setMessage({ character: joe.character, text: `Thanks anyway bro.` });
            }
        }
        // TODO: if not always doing threesome, some messages for asking the car for Jenny's date

        if (mc.properties.hasJennysNumber) {
            if (mc.properties.v8WentToThreesome || Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessa) {
                Phone.setMessage({
                    character: mc.character, text: `Hey, I wanted to ask you something...
Do you think I could borrow your car?` });
                Phone.setMessage({ character: joe.character, text: `Are you going out on a date with Jenny again?` });
                Phone.setMessage({ character: mc.character, text: `I hope so, I haven't invited her yet.` });
                Phone.setMessage({ character: joe.character, text: `No way she'll turn you down!` });
            } else {
                Phone.setMessage({ character: mc.character, text: `It's a bit awkward to ask this now but do you think I can borrow your car?` });
                Phone.setMessage({ character: mc.character, text: `I was thinking about going out with Jenny again.` });
                Phone.setMessage({ character: joe.character, text: `Of course man, that doesn't change anything.` });
            }
        }
        Phone.setMessage({ character: joe.character, text: `I'll bring the car over right now.` });
        Phone.setMessage({ character: mc.character, text: `Thanks man!` });

        Phone.closeMessagesUI();
    });
    ImageClass.setImage(images.v8.V8RoomNight);

    return jump(V8JoeCallingAfter, "V8JoeCallingAfter");
};

async function V8JoeCallingAskForTheCar() {

}